import { render, staticRenderFns } from "./Bimini_dessert.vue?vue&type=template&id=473398c9&scoped=true"
import script from "./Bimini_dessert.vue?vue&type=script&lang=ts"
export * from "./Bimini_dessert.vue?vue&type=script&lang=ts"
import style0 from "./Bimini_dessert.vue?vue&type=style&index=0&id=473398c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473398c9",
  null
  
)

export default component.exports